import { PAID_POSTING_SOURCE, OPN_SOURCE, JOB_BOARD_BUNDLE_SOURCE } from '../constants/candidates';

export default function getSource(searchParams) {
  // NOTE: For Vonq's paid posting campaigns
  if (
    searchParams.get('source') === PAID_POSTING_SOURCE
    && searchParams.get('utmSource') && searchParams.get('utmSource').length > 0
  ) {
    if (
      searchParams.get('utmSource') === JOB_BOARD_BUNDLE_SOURCE
      && document.referrer && document.referrer.length > 0
    ) {
      let referrer;
      try {
        referrer = new URL(document.referrer).host;
      } catch (error) {
        referrer = document.referrer;
      }

      return `${referrer} - ${searchParams.get('utmSource')} - ${searchParams.get('source')}`;
    }

    return `${searchParams.get('utmSource')} - ${searchParams.get('source')}`;
  }

  // NOTE: For Vonq's OPN campaigns
  if (
    searchParams.get('source') === OPN_SOURCE
    && document.referrer && document.referrer.length > 0
  ) {
    let referrer;
    try {
      referrer = new URL(document.referrer).host;
    } catch (error) {
      referrer = document.referrer;
    }
    return `${referrer} - ${searchParams.get('source')}`;
  }

  if (
    (searchParams.get('lead') == null || searchParams.get('lead').length === 0)
    && (searchParams.get('source') == null || searchParams.get('source').length === 0)
    && window.LANDINGPAGE.source
  ) {
    return window.LANDINGPAGE.source;
  }

  return searchParams.get('source') || searchParams.get('lead');
}
